import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeVendorAsync,
  getUserJobByIdAsync,
  applyCustomChargeAsync,
  makeJobAvailableAsync,
  updateAdminOrderAsync,
} from "../../../services/UserJobsServices";
import { get_services_list } from "../../../services/DashboardServices";
import { useNavigate, useParams } from "react-router-dom";
import { asyncStatus } from "../../../utils/asyncStatus";
import {
  Avatar,
  Box,
  Card,
  Chip,
  CircularProgress,
  Container,
  Divider,
  Grid,
  ImageList,
  ImageListItem,
  Stack,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  InputAdornment,
} from "@mui/material";
import { themeOrange } from "../../../utils/colorTheme";
import {
  AccessTime,
  AttachMoney,
  CalendarToday,
  LocationOn,
} from "@mui/icons-material";
import { HiMiniCalendar } from "react-icons/hi2";
import { img_url } from "../../../utils/helper/urls";
import CustomSelectBox from "../../../component/common/selectComp/CustomSelectBox";
import CustomButton from "../../../component/common/Button/Button";
import { setChangeVendorStatus } from "../../../store/slices/UserJobsSlice";
import { TbEdit } from "react-icons/tb";
import { success_toast_message, error_toast_message } from "../../../utils/toast_message";
import { get_notes_by_user, add_note_async, delete_note_async, edit_note_async } from "../../../services/NotesService";
import { clearUserNotes } from "../../../store/slices/notesSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";

const OrderDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [vendorId, setVendorId] = useState({});
  const [isShowVendor, setIsShowVendor] = useState("");

  // Custom billing states
  const [billingDialog, setBillingDialog] = useState(false);
  const [billingAmount, setBillingAmount] = useState("");
  const [billingReason, setBillingReason] = useState("");
  const [billingLoading, setBillingLoading] = useState(false);
  const [billingError, setBillingError] = useState("");

  // Make job available states
  const [makeAvailableDialog, setMakeAvailableDialog] = useState(false);
  const [makeAvailableLoading, setMakeAvailableLoading] = useState(false);

  // Change service states
  const [serviceDialog, setServiceDialog] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [serviceLoading, setServiceLoading] = useState(false);

  // Notes states
  const [newNote, setNewNote] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [editingNoteText, setEditingNoteText] = useState("");

  // Materials amount states (exempt from percentage)
  const [materialsDialog, setMaterialsDialog] = useState(false);
  const [materialsAmount, setMaterialsAmount] = useState("");
  const [materialsLoading, setMaterialsLoading] = useState(false);
  const [materialsError, setMaterialsError] = useState("");

  // Process payment states
  const [processPaymentDialog, setProcessPaymentDialog] = useState(false);
  const [processPaymentLoading, setProcessPaymentLoading] = useState(false);
  const [additionalItems, setAdditionalItems] = useState([]);
  const [newItemName, setNewItemName] = useState("");
  const [newItemPrice, setNewItemPrice] = useState("");

  const {
    get_user_job_by_id_status,
    get_user_job_by_id_data,
    change_vendor_status,
    change_vendor_data,
  } = useSelector((state) => state.userJobsSlice);

  // Get services from Redux
  const { get_services_list_data, get_services_list_status } = useSelector(
    (state) => state.dashaboard_services
  );

  // Get notes from Redux
  const {
    get_notes_by_user_status,
    get_notes_by_user_data,
    add_note_status,
    delete_note_status,
    edit_note_status,
  } = useSelector((state) => state.notes);

  const changeVendorLoader = change_vendor_status === asyncStatus.LOADING;

  //   console.log(
  //     ">>>>>>>>>>>",
  //     get_user_job_by_id_data.order.status === "Assigned" ||
  //       get_user_job_by_id_data.order.status === "In-Queue"
  //   );

  const _handleAssignedVendor = () => {
    const finalObj = {
      oid: id,
      ven_id: vendorId.value,
    };
    console.log("final obje", finalObj);
    dispatch(changeVendorAsync(finalObj));
  };

  // Custom billing handlers
  const handleOpenBillingDialog = () => {
    setBillingDialog(true);
    setBillingAmount("");
    setBillingReason("");
    setBillingError("");
  };

  const handleCloseBillingDialog = () => {
    setBillingDialog(false);
    setBillingAmount("");
    setBillingReason("");
    setBillingError("");
  };

  const handleBillingSubmit = async () => {
    if (!billingAmount || parseFloat(billingAmount) <= 0) {
      setBillingError("Please enter a valid amount greater than 0");
      return;
    }
    if (!billingReason.trim()) {
      setBillingError("Please provide a reason for this charge");
      return;
    }

    setBillingLoading(true);
    setBillingError("");

    try {
      const result = await dispatch(
        applyCustomChargeAsync({
          orderId: id,
          amount: parseFloat(billingAmount),
          reason: billingReason.trim(),
        })
      ).unwrap();

      if (result.status) {
        success_toast_message(result.message || "Custom charge applied successfully");
        handleCloseBillingDialog();
        // Refresh order data
        dispatch(getUserJobByIdAsync(id));
      } else {
        setBillingError(result.message || "Failed to apply charge");
      }
    } catch (error) {
      setBillingError(error || "Failed to apply charge. Please try again.");
      error_toast_message(error || "Failed to apply charge");
    } finally {
      setBillingLoading(false);
    }
  };

  // Make job available handlers
  const handleMakeAvailable = async () => {
    setMakeAvailableLoading(true);
    try {
      const result = await dispatch(
        makeJobAvailableAsync({ orderId: id })
      ).unwrap();

      if (result.status) {
        success_toast_message(result.message || "Job is now available for pros");
        setMakeAvailableDialog(false);
        // Refresh order data
        dispatch(getUserJobByIdAsync(id));
      } else {
        error_toast_message(result.message || "Failed to make job available");
      }
    } catch (error) {
      error_toast_message(error || "Failed to make job available");
    } finally {
      setMakeAvailableLoading(false);
    }
  };

  // Change service handlers
  const handleOpenServiceDialog = () => {
    setServiceDialog(true);
    setSelectedService(null);
    // Fetch services if not already loaded
    if (!get_services_list_data || get_services_list_data.length === 0) {
      dispatch(get_services_list());
    }
  };

  const handleCloseServiceDialog = () => {
    setServiceDialog(false);
    setSelectedService(null);
  };

  const handleChangeService = async () => {
    if (!selectedService) {
      error_toast_message("Please select a service");
      return;
    }

    setServiceLoading(true);
    try {
      const result = await dispatch(
        updateAdminOrderAsync({
          id: id,
          data: { service_id: selectedService.value },
        })
      ).unwrap();

      success_toast_message("Service changed successfully");
      handleCloseServiceDialog();
      // Refresh order data
      dispatch(getUserJobByIdAsync(id));
    } catch (error) {
      error_toast_message(error || "Failed to change service");
    } finally {
      setServiceLoading(false);
    }
  };

  // Format services for select dropdown
  const serviceOptions =
    get_services_list_data?.map((service) => ({
      value: service.id,
      label: `${service.name} - $${service.price}`,
      service: service,
    })) || [];

  // Note handlers
  const handleAddNote = () => {
    const userId = get_user_job_by_id_data?.order?.user?.id;
    if (newNote.trim() && userId) {
      dispatch(add_note_async({ userId: userId, note: newNote }));
      setNewNote("");
    }
  };

  const handleDeleteNote = (noteId) => {
    dispatch(delete_note_async(noteId));
  };

  const handleEditNote = (note) => {
    setEditingNoteId(note.id);
    setEditingNoteText(note.note);
  };

  const handleSaveEdit = () => {
    const userId = get_user_job_by_id_data?.order?.user?.id;
    if (editingNoteText.trim() && userId) {
      dispatch(edit_note_async({ id: editingNoteId, data: { userId: userId, note: editingNoteText } }));
      setEditingNoteId(null);
      setEditingNoteText("");
    }
  };

  const handleCancelEdit = () => {
    setEditingNoteId(null);
    setEditingNoteText("");
  };

  // Materials amount handlers
  const handleOpenMaterialsDialog = () => {
    setMaterialsDialog(true);
    // Pre-fill with existing materials amount if any
    setMaterialsAmount(get_user_job_by_id_data?.order?.materials_amount || "");
    setMaterialsError("");
  };

  const handleCloseMaterialsDialog = () => {
    setMaterialsDialog(false);
    setMaterialsAmount("");
    setMaterialsError("");
  };

  const handleMaterialsSubmit = async () => {
    const amount = parseFloat(materialsAmount) || 0;

    if (amount < 0) {
      setMaterialsError("Materials amount cannot be negative");
      return;
    }

    setMaterialsLoading(true);
    setMaterialsError("");

    try {
      const result = await dispatch(
        updateAdminOrderAsync({
          id: id,
          data: { materials_amount: amount },
        })
      ).unwrap();

      success_toast_message("Materials amount updated successfully");
      handleCloseMaterialsDialog();
      // Refresh order data
      dispatch(getUserJobByIdAsync(id));
    } catch (error) {
      setMaterialsError(error || "Failed to update materials amount");
      error_toast_message(error || "Failed to update materials amount");
    } finally {
      setMaterialsLoading(false);
    }
  };

  // Process payment handlers
  const handleOpenProcessPayment = () => {
    setProcessPaymentDialog(true);
    setAdditionalItems([]);
    setNewItemName("");
    setNewItemPrice("");
  };

  const handleCloseProcessPayment = () => {
    setProcessPaymentDialog(false);
    setAdditionalItems([]);
    setNewItemName("");
    setNewItemPrice("");
  };

  const handleAddItem = () => {
    if (!newItemName.trim()) {
      error_toast_message("Please enter item name");
      return;
    }
    if (!newItemPrice || parseFloat(newItemPrice) <= 0) {
      error_toast_message("Please enter a valid price");
      return;
    }
    setAdditionalItems([
      ...additionalItems,
      { name: newItemName.trim(), price: parseFloat(newItemPrice) },
    ]);
    setNewItemName("");
    setNewItemPrice("");
  };

  const handleRemoveItem = (index) => {
    setAdditionalItems(additionalItems.filter((_, i) => i !== index));
  };

  const calculateProcessPaymentTotal = () => {
    const orderTotal = parseFloat(get_user_job_by_id_data?.order?.total_amount) || 0;
    const materialsTotal = parseFloat(get_user_job_by_id_data?.order?.materials_amount) || 0;
    const additionalTotal = additionalItems.reduce((sum, item) => sum + item.price, 0);
    return orderTotal + materialsTotal + additionalTotal;
  };

  const handleProcessPayment = async () => {
    setProcessPaymentLoading(true);
    try {
      const totalAmount = calculateProcessPaymentTotal();
      const result = await dispatch(
        applyCustomChargeAsync({
          orderId: id,
          amount: totalAmount,
          reason: `Order payment - Order #${id}${additionalItems.length > 0 ? ` + ${additionalItems.length} additional item(s)` : ""}`,
          additionalItems: additionalItems,
        })
      ).unwrap();

      if (result.status) {
        success_toast_message("Payment processed successfully!");
        handleCloseProcessPayment();
        dispatch(getUserJobByIdAsync(id));
      } else {
        error_toast_message(result.message || "Failed to process payment");
      }
    } catch (error) {
      error_toast_message(error || "Failed to process payment");
    } finally {
      setProcessPaymentLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getUserJobByIdAsync(id));

    return () => {
      dispatch(clearUserNotes());
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (Object.keys(get_user_job_by_id_data?.order || {})?.length > 0) {
      const isVendorAssigned = {
        value: get_user_job_by_id_data?.order?.vendor?.id,
        label: `${get_user_job_by_id_data?.order?.pro?.first_name} ${get_user_job_by_id_data?.order?.pro?.last_name}`,
      };
      setVendorId(isVendorAssigned);

      // Fetch notes for the user
      if (get_user_job_by_id_data?.order?.user?.id) {
        dispatch(get_notes_by_user(get_user_job_by_id_data.order.user.id));
      }
    }
  }, [get_user_job_by_id_data, dispatch]);

  useEffect(() => {
    if (change_vendor_status === asyncStatus.SUCCEEDED) {
      setIsShowVendor(false);
      dispatch(setChangeVendorStatus());
    }
  }, [change_vendor_status]);

  const allVendors =
    get_user_job_by_id_data?.vendors?.map((vendor) => ({
      value: vendor?.id,
      label: `${vendor?.first_name} ${vendor?.last_name}`,
    })) || [];

  const isVendorsShow =
    get_user_job_by_id_data?.order?.status === "Assigned" ||
    get_user_job_by_id_data?.order?.status === "In-Queue";

  if (get_user_job_by_id_status === asyncStatus.LOADING) {
    return (
      <Stack
        alignItems={"center"}
        justifyContent={"center"}
        sx={{ height: "50vh" }}
      >
        <CircularProgress size={30} sx={{ color: themeOrange }} />
      </Stack>
    );
  }
  console.clear();
  console.log(get_user_job_by_id_data?.order);
  return (
    <Stack bgcolor={"#FAFAFA"}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        gap={1}
        my={1}
      >
        <Typography className="mainHeading">Order Detail {id ? `#${id}` : ""}</Typography>
        <Stack
          //   className="globleGradientBlue"
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
          sx={{ borderRadius: "10px", overflow: "hidden", boxShadow: "none" }}
        >
          <CustomButton
            onClick={() => navigate(`/orders/edit-order/${id}`)}
            style={{
              background:
                "var(--Orange, linear-gradient(180deg, #F15A24 0%, #C53F10 100%))",
              padding: "10px 17px",
              borderRadius: "100px",
            }}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <TbEdit size={15} color={"white"} />
              <Typography sx={{ fontSize: "13px !important" }}>
                Edit Order
              </Typography>
            </Stack>
          </CustomButton>
          <Chip
            label={get_user_job_by_id_data?.order?.status}
            sx={{
              //   backgroundColor:
              //     get_user_job_by_id_data?.order?.status === "Completed"
              //       ? "#b1f3b1"
              //       : "#f5bdbd9e",
              backgroundColor:
                get_user_job_by_id_data?.order?.status === "Completed"
                  ? "#b1f3b1"
                  : get_user_job_by_id_data?.order?.status === "Assigned"
                  ? "#b3d9ff"
                  : get_user_job_by_id_data?.order?.status === "In-Queue"
                  ? "#ffe5b4"
                  : "#f5bdbd9e",
              //   color:
              //     get_user_job_by_id_data?.order?.status === "Completed"
              //       ? "green"
              //       : "red",
              color:
                get_user_job_by_id_data?.order?.status === "Completed"
                  ? "green"
                  : get_user_job_by_id_data?.order?.status === "Assigned"
                  ? "#0056b3"
                  : get_user_job_by_id_data?.order?.status === "In-Queue"
                  ? "#cc7000"
                  : "red",
              fontWeight: "bold",
              // mt: 1,
              padding: "10px 17px",
            }}
          />
        </Stack>
      </Stack>
      <Divider />
      <Container
        sx={{ maxWidth: { xl: "xl", lg: "lg", md: "md", sm: "sm", xs: "xs" } }}
      >
        {Object.keys(get_user_job_by_id_data?.order || {})?.length === 0 ? (
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            sx={{ height: "50vh" }}
          >
            <Typography>No orders found</Typography>
          </Stack>
        ) : (
          <Stack spacing={3} my={3}>
            {/* Top Info Cards Row */}
            <Grid container spacing={2}>
              {/* Service Card */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    padding: "20px",
                    border: "1px solid #e0e0e0",
                    height: "100%",
                  }}
                >
                  <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                    Service
                  </Typography>
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    <Avatar
                      src={`${img_url}${get_user_job_by_id_data?.order?.service?.image}`}
                      sx={{ height: "60px", width: "60px", borderRadius: "8px", backgroundColor: "#f5f5f5" }}
                    />
                    <Stack spacing={0.5} flex={1}>
                      <Typography sx={{ fontSize: "18px", fontWeight: "700", color: "#1a1a1a" }}>
                        {get_user_job_by_id_data?.order?.service?.name}
                      </Typography>
                      <Typography sx={{ fontSize: "13px", color: "#666", lineHeight: 1.5 }}>
                        {get_user_job_by_id_data?.order?.service?.description}
                      </Typography>
                      <Typography sx={{ fontSize: "16px", fontWeight: "600", color: themeOrange, mt: 1 }}>
                        ${get_user_job_by_id_data?.order?.service?.price?.toLocaleString()}
                      </Typography>
                      {(get_user_job_by_id_data?.order?.status === "In-Queue" ||
                        get_user_job_by_id_data?.order?.status === "Assigned") && (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={handleOpenServiceDialog}
                          sx={{ mt: 1, borderColor: "#ddd", color: "#666", fontSize: "12px", textTransform: "none", width: "fit-content" }}
                        >
                          Change Service
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                </Box>
              </Grid>

              {/* Schedule & Location Card */}
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    padding: "20px",
                    border: "1px solid #e0e0e0",
                    height: "100%",
                  }}
                >
                  <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                    Schedule & Location
                  </Typography>

                  {/* Scheduled Date */}
                  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Box sx={{ backgroundColor: get_user_job_by_id_data?.order?.date_time_lock?.date ? "#e3f2fd" : "#fff3e0", borderRadius: "8px", p: 1.5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <CalendarToday sx={{ color: get_user_job_by_id_data?.order?.date_time_lock?.date ? "#1565c0" : "#e65100", fontSize: "24px" }} />
                    </Box>
                    <Stack>
                      <Typography sx={{ fontSize: "12px", color: "#888", fontWeight: "500" }}>Scheduled Date</Typography>
                      <Typography sx={{ fontSize: "16px", fontWeight: "600", color: get_user_job_by_id_data?.order?.date_time_lock?.date ? "#1a1a1a" : "#e65100" }}>
                        {get_user_job_by_id_data?.order?.date_time_lock?.date
                          ? (() => {
                              const datePart = String(get_user_job_by_id_data.order.date_time_lock.date).split('T')[0];
                              const [year, month, day] = datePart.split('-');
                              const date = new Date(Number(year), Number(month) - 1, Number(day));
                              return isNaN(date.getTime())
                                ? "Not Scheduled Yet"
                                : date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" });
                            })()
                          : "Not Scheduled Yet"}
                        {get_user_job_by_id_data?.order?.date_time_lock?.shift && (
                          <Typography component="span" sx={{ color: "#666", fontWeight: "400" }}> ({get_user_job_by_id_data.order.date_time_lock.shift})</Typography>
                        )}
                      </Typography>
                    </Stack>
                  </Stack>

                  {/* Location */}
                  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Box sx={{ backgroundColor: "#fce6de", borderRadius: "8px", p: 1.5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <LocationOn sx={{ color: themeOrange, fontSize: "24px" }} />
                    </Box>
                    <Stack>
                      <Typography sx={{ fontSize: "12px", color: "#888", fontWeight: "500" }}>Location</Typography>
                      <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "#1a1a1a" }}>
                        {get_user_job_by_id_data?.order?.location || "No location"}
                      </Typography>
                    </Stack>
                  </Stack>

                  {/* Created Date */}
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ backgroundColor: "#f5f5f5", borderRadius: "8px", p: 1.5, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <AccessTime sx={{ color: "#666", fontSize: "24px" }} />
                    </Box>
                    <Stack>
                      <Typography sx={{ fontSize: "12px", color: "#888", fontWeight: "500" }}>Order Created</Typography>
                      <Typography sx={{ fontSize: "14px", fontWeight: "500", color: "#1a1a1a" }}>
                        {new Date(get_user_job_by_id_data?.order?.created_at)?.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric", year: "numeric" })}
                      </Typography>
                    </Stack>
                  </Stack>
                </Box>
              </Grid>
            </Grid>

              {/* Pricing & Payment Card */}
              <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", padding: "24px", border: "1px solid #e0e0e0" }}>
                <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                  Pricing
                </Typography>

                {/* Price rows */}
                <Stack spacing={1.5}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography sx={{ fontSize: "14px", color: "#666" }}>Service Amount</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1a1a1a" }}>
                      ${get_user_job_by_id_data?.order?.service_amount ? parseFloat(get_user_job_by_id_data.order.service_amount).toFixed(2) : "0.00"}
                    </Typography>
                  </Stack>

                  {/* Additional Items inline */}
                  {(() => {
                    let addOns = get_user_job_by_id_data?.order?.add_ons;
                    if (typeof addOns === 'string') { try { addOns = JSON.parse(addOns); } catch (e) { addOns = []; } }
                    if (Array.isArray(addOns) && addOns.length > 0) {
                      return addOns.map((addon, index) => (
                        <Stack key={index} direction="row" justifyContent="space-between">
                          <Typography sx={{ fontSize: "14px", color: "#666" }}>{addon?.name || "Item"}</Typography>
                          <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1a1a1a" }}>${addon?.price ? Number(addon.price).toFixed(2) : "0.00"}</Typography>
                        </Stack>
                      ));
                    }
                    return null;
                  })()}

                  <Stack direction="row" justifyContent="space-between">
                    <Typography sx={{ fontSize: "14px", color: "#666" }}>
                      Subtotal
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1a1a1a" }}>
                      ${(() => {
                        const serviceAmount = parseFloat(get_user_job_by_id_data?.order?.service_amount) || 0;
                        let addOns = get_user_job_by_id_data?.order?.add_ons;
                        if (typeof addOns === 'string') { try { addOns = JSON.parse(addOns); } catch (e) { addOns = []; } }
                        const addonsTotal = Array.isArray(addOns) ? addOns.reduce((sum, addon) => sum + (parseFloat(addon?.price) || 0), 0) : 0;
                        return (serviceAmount + addonsTotal).toFixed(2);
                      })()}
                    </Typography>
                  </Stack>

                  <Stack direction="row" justifyContent="space-between">
                    <Typography sx={{ fontSize: "14px", color: "#666" }}>Tax (13% HST)</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1a1a1a" }}>
                      ${get_user_job_by_id_data?.order?.tax ? parseFloat(get_user_job_by_id_data.order.tax).toFixed(2) : "0.00"}
                    </Typography>
                  </Stack>

                  {/* Materials */}
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography sx={{ fontSize: "14px", color: "#666" }}>Materials</Typography>
                      <Button size="small" onClick={handleOpenMaterialsDialog} sx={{ fontSize: "11px", textTransform: "none", color: "#1976d2", minWidth: "auto", padding: "0 4px" }}>
                        {get_user_job_by_id_data?.order?.materials_amount ? "(Edit)" : "(Set)"}
                      </Button>
                    </Stack>
                    <Typography sx={{ fontSize: "14px", fontWeight: "600", color: "#1a1a1a" }}>
                      ${get_user_job_by_id_data?.order?.materials_amount ? parseFloat(get_user_job_by_id_data.order.materials_amount).toFixed(2) : "0.00"}
                    </Typography>
                  </Stack>

                  <Divider />

                  {/* Total */}
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography sx={{ fontSize: "18px", fontWeight: "700", color: "#1a1a1a" }}>Total</Typography>
                    <Typography sx={{ fontSize: "24px", fontWeight: "700", color: themeOrange }}>
                      ${get_user_job_by_id_data?.order?.total_amount ? parseFloat(get_user_job_by_id_data.order.total_amount).toFixed(2) : "0.00"}
                    </Typography>
                  </Stack>
                </Stack>

                {/* Process Payment Button */}
                {get_user_job_by_id_data?.order?.status !== "Paid" &&
                  get_user_job_by_id_data?.order?.status !== "Refunded" &&
                  get_user_job_by_id_data?.order?.status !== "Cancelled" && (
                  <Button
                    fullWidth
                    onClick={handleOpenProcessPayment}
                    sx={{
                      background: "linear-gradient(180deg, #4CAF50 0%, #388E3C 100%)",
                      color: "white",
                      fontWeight: "600",
                      fontSize: "15px",
                      padding: "12px 20px",
                      borderRadius: "8px",
                      mt: 3,
                      textTransform: "none",
                      "&:hover": { background: "linear-gradient(180deg, #388E3C 0%, #2E7D32 100%)" },
                    }}
                  >
                    Process Order Payment
                  </Button>
                )}
              </Box>

              {/* Job Description Card */}
              <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", padding: "24px", border: "1px solid #e0e0e0" }}>
                <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                  Job Description
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: get_user_job_by_id_data?.order?.description ? "#444" : "#999",
                    lineHeight: 1.7,
                    fontStyle: get_user_job_by_id_data?.order?.description ? "normal" : "italic",
                  }}
                >
                  {get_user_job_by_id_data?.order?.description || "No description provided by customer"}
                </Typography>
              </Box>

              {/* Customer & Vendor Cards */}
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", padding: "20px", border: "1px solid #e0e0e0", height: "100%" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                      Customer
                    </Typography>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Avatar src={get_user_job_by_id_data?.order?.user?.avatar} sx={{ width: 50, height: 50 }} />
                      <Stack>
                        <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#1a1a1a" }}>
                          {`${get_user_job_by_id_data?.order?.user?.first_name} ${get_user_job_by_id_data?.order?.user?.last_name}`}
                        </Typography>
                        <Typography sx={{ fontSize: "13px", color: "#666" }}>
                          {get_user_job_by_id_data?.order?.user?.email}
                        </Typography>
                        <Typography sx={{ fontSize: "13px", color: "#666" }}>
                          {get_user_job_by_id_data?.order?.user?.phone}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  {Object.keys(get_user_job_by_id_data?.order?.vendor || {})?.length > 0 ? (
                    <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", padding: "20px", border: "1px solid #e0e0e0", height: "100%" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                        Assigned Pro
                      </Typography>
                      <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar src={get_user_job_by_id_data?.order?.vendor?.avatar} sx={{ width: 50, height: 50 }} />
                        <Stack>
                          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#1a1a1a" }}>
                            {`${get_user_job_by_id_data?.order?.pro?.first_name} ${get_user_job_by_id_data?.order?.pro?.last_name}`}
                          </Typography>
                          <Typography sx={{ fontSize: "13px", color: "#666" }}>
                            {get_user_job_by_id_data?.order?.vendor?.email}
                          </Typography>
                          <Typography sx={{ fontSize: "13px", color: "#666" }}>
                            {get_user_job_by_id_data?.order?.vendor?.phone}
                          </Typography>
                        </Stack>
                      </Stack>
                      {/* Make Job Available Button */}
                      {get_user_job_by_id_data?.order?.status !== "Completed" && (
                        <Button
                          size="small"
                          onClick={() => setMakeAvailableDialog(true)}
                          sx={{ mt: 2, color: "#FF5722", borderColor: "#FF5722", fontSize: "12px", textTransform: "none" }}
                          variant="outlined"
                        >
                          Make Job Available Again
                        </Button>
                      )}
                    </Box>
                  ) : (
                    <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", padding: "20px", border: "1px solid #e0e0e0", height: "100%" }}>
                      <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                        Assigned Pro
                      </Typography>
                      <Typography sx={{ fontSize: "14px", color: "#999", fontStyle: "italic" }}>
                        No pro assigned yet
                      </Typography>
                    </Box>
                  )}
                </Grid>
              </Grid>

              {/* Reassign Vendor Section */}
              {Object.keys(get_user_job_by_id_data?.order?.vendor || {})?.length > 0 && (
                <Box sx={{ backgroundColor: "#fff", borderRadius: "12px", padding: "20px", border: "1px solid #e0e0e0" }}>
                  <Typography sx={{ fontSize: "13px", fontWeight: "600", color: "#888", textTransform: "uppercase", letterSpacing: "0.5px", mb: 2 }}>
                    Reassign Pro
                  </Typography>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box sx={{ flex: 1 }}>
                      <CustomSelectBox
                        options={allVendors}
                        isMulti={false}
                        value={vendorId}
                        onChange={(e) => setVendorId(e)}
                        placeholder={"Select a pro"}
                        customStyles={{
                          control: { borderRadius: "8px", height: "auto", minHeight: "42px", width: "100%" },
                        }}
                      />
                    </Box>
                    <Button
                      disabled={changeVendorLoader}
                      onClick={_handleAssignedVendor}
                      variant="contained"
                      sx={{
                        background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                        color: "white",
                        textTransform: "none",
                        padding: "10px 24px",
                        borderRadius: "8px",
                        "&:hover": { background: "linear-gradient(180deg, #C53F10 0%, #A03000 100%)" },
                      }}
                    >
                      {changeVendorLoader ? <CircularProgress size={18} sx={{ color: "white" }} /> : "Reassign"}
                    </Button>
                  </Stack>
                </Box>
              )}

              {/* Admin Notes Section */}
              <Stack
                sx={{
                  backgroundColor: "#f9f9f9",
                  borderRadius: "12px",
                  padding: "20px",
                  border: "1px solid #e0e0e0",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#333",
                      }}
                    >
                      Admin Notes for {get_user_job_by_id_data?.order?.user?.first_name}
                    </Typography>
                    <Typography sx={{ fontSize: "12px", color: "#888", mt: 0.5 }}>
                      Private notes about this customer (only visible to admins)
                    </Typography>
                  </Box>
                </Stack>

                {/* Add New Note */}
                <Stack
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "16px",
                    border: "1px solid #eee",
                    mb: 2,
                  }}
                >
                  <TextField
                    multiline
                    rows={2}
                    placeholder="Write a note about this customer..."
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        fontSize: "14px",
                      },
                    }}
                  />
                  <Stack direction="row" justifyContent="flex-end" mt={1}>
                    <CustomButton
                      onClick={handleAddNote}
                      disable={!newNote.trim() || add_note_status === asyncStatus.LOADING}
                      style={{
                        background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
                        padding: "8px 20px",
                        borderRadius: "8px",
                        opacity: !newNote.trim() ? 0.6 : 1,
                      }}
                    >
                      {add_note_status === asyncStatus.LOADING ? (
                        <CircularProgress size={16} sx={{ color: "white" }} />
                      ) : (
                        <Typography sx={{ fontSize: "13px !important" }}>Add Note</Typography>
                      )}
                    </CustomButton>
                  </Stack>
                </Stack>

                {/* Notes List */}
                <Stack gap={2} sx={{ maxHeight: "300px", overflow: "auto" }}>
                  {get_notes_by_user_status === asyncStatus.LOADING ? (
                    <Stack alignItems="center" py={4}>
                      <CircularProgress size={24} sx={{ color: themeOrange }} />
                    </Stack>
                  ) : get_notes_by_user_data?.length > 0 ? (
                    get_notes_by_user_data.map((note) => (
                      <Box
                        key={note.id}
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          border: "1px solid #eee",
                        }}
                      >
                        {editingNoteId === note.id ? (
                          <Stack gap={1}>
                            <TextField
                              multiline
                              rows={2}
                              value={editingNoteText}
                              onChange={(e) => setEditingNoteText(e.target.value)}
                              fullWidth
                              size="small"
                              sx={{
                                "& .MuiOutlinedInput-root": {
                                  borderRadius: "8px",
                                  fontSize: "14px",
                                },
                              }}
                            />
                            <Stack direction="row" justifyContent="flex-end" gap={1}>
                              <Button
                                size="small"
                                onClick={handleCancelEdit}
                                sx={{ color: "#888" }}
                              >
                                <CancelIcon fontSize="small" />
                              </Button>
                              <Button
                                size="small"
                                onClick={handleSaveEdit}
                                sx={{ color: themeOrange }}
                                disabled={edit_note_status === asyncStatus.LOADING}
                              >
                                {edit_note_status === asyncStatus.LOADING ? (
                                  <CircularProgress size={16} />
                                ) : (
                                  <SaveIcon fontSize="small" />
                                )}
                              </Button>
                            </Stack>
                          </Stack>
                        ) : (
                          <>
                            <Typography sx={{ fontSize: "14px", color: "#333", lineHeight: 1.6 }}>
                              {note.note}
                            </Typography>
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              mt={1}
                            >
                              <Typography sx={{ fontSize: "11px", color: "#999" }}>
                                {new Date(note.created_at).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                })}
                              </Typography>
                              <Stack direction="row" gap={0.5}>
                                <Button
                                  size="small"
                                  onClick={() => handleEditNote(note)}
                                  sx={{ minWidth: "auto", color: "#666", "&:hover": { color: themeOrange } }}
                                >
                                  <EditIcon fontSize="small" />
                                </Button>
                                <Button
                                  size="small"
                                  onClick={() => handleDeleteNote(note.id)}
                                  sx={{ minWidth: "auto", color: "#666", "&:hover": { color: "#d32f2f" } }}
                                  disabled={delete_note_status === asyncStatus.LOADING}
                                >
                                  <DeleteIcon fontSize="small" />
                                </Button>
                              </Stack>
                            </Stack>
                          </>
                        )}
                      </Box>
                    ))
                  ) : (
                    <Stack alignItems="center" py={3}>
                      <Typography sx={{ fontSize: "14px", color: "#999", fontStyle: "italic" }}>
                        No notes yet. Add your first note above.
                      </Typography>
                    </Stack>
                  )}
                </Stack>
              </Stack>
          </Stack>
        )}
      </Container>

      {/* Custom Billing Dialog */}
      <Dialog
        open={billingDialog}
        onClose={handleCloseBillingDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: themeOrange,
            color: "white",
            fontWeight: "700",
          }}
        >
          Bill Client Custom Amount
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Stack spacing={3} sx={{ pt: 1 }}>
            <Typography variant="body2" color="textSecondary">
              Enter the amount you want to charge the client. This will create a new charge on their payment method.
            </Typography>

            <TextField
              label="Amount"
              type="number"
              value={billingAmount}
              onChange={(e) => setBillingAmount(e.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              inputProps={{ min: 0, step: "0.01" }}
              placeholder="0.00"
            />

            <TextField
              label="Reason for charge"
              multiline
              rows={3}
              value={billingReason}
              onChange={(e) => setBillingReason(e.target.value)}
              fullWidth
              placeholder="e.g., Additional work requested, Material costs, etc."
            />

            {billingError && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {billingError}
              </Alert>
            )}

            <Box
              sx={{
                backgroundColor: "#FFF8F5",
                padding: "12px",
                borderRadius: "8px",
                border: `1px solid ${themeOrange}30`,
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <strong>Customer:</strong>{" "}
                {get_user_job_by_id_data?.order?.user?.first_name}{" "}
                {get_user_job_by_id_data?.order?.user?.last_name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Email:</strong>{" "}
                {get_user_job_by_id_data?.order?.user?.email}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Order ID:</strong> {id}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={handleCloseBillingDialog}
            disabled={billingLoading}
            sx={{ color: "gray" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleBillingSubmit}
            disabled={billingLoading}
            variant="contained"
            sx={{
              background: "linear-gradient(180deg, #4CAF50 0%, #388E3C 100%)",
              "&:hover": {
                background: "linear-gradient(180deg, #388E3C 0%, #2E7D32 100%)",
              },
            }}
          >
            {billingLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              `Charge $${billingAmount || "0.00"}`
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Make Job Available Confirmation Dialog */}
      <Dialog
        open={makeAvailableDialog}
        onClose={() => setMakeAvailableDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#FF5722",
            color: "white",
            fontWeight: "700",
          }}
        >
          Make Job Available Again
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Alert severity="warning">
              This will unassign the current pro and make the job available for other pros to accept.
            </Alert>

            <Typography variant="body1">
              Are you sure you want to make this job available again?
            </Typography>

            <Box
              sx={{
                backgroundColor: "#FFF3E0",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #FFE0B2",
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <strong>Current Vendor:</strong>{" "}
                {get_user_job_by_id_data?.order?.vendor?.first_name}{" "}
                {get_user_job_by_id_data?.order?.vendor?.last_name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Service:</strong>{" "}
                {get_user_job_by_id_data?.order?.service?.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Order ID:</strong> {id}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={() => setMakeAvailableDialog(false)}
            disabled={makeAvailableLoading}
            sx={{ color: "gray" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleMakeAvailable}
            disabled={makeAvailableLoading}
            variant="contained"
            sx={{
              background: "linear-gradient(180deg, #FF5722 0%, #E64A19 100%)",
              "&:hover": {
                background: "linear-gradient(180deg, #E64A19 0%, #D84315 100%)",
              },
            }}
          >
            {makeAvailableLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              "Yes, Make Available"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Change Service Dialog */}
      <Dialog
        open={serviceDialog}
        onClose={handleCloseServiceDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: themeOrange,
            color: "white",
            fontWeight: "700",
          }}
        >
          Change Service
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Stack spacing={3} sx={{ pt: 1 }}>
            <Typography variant="body2" color="textSecondary">
              Select a new service for this order. The price will be updated automatically.
            </Typography>

            <Box
              sx={{
                backgroundColor: "#FFF8F5",
                padding: "12px",
                borderRadius: "8px",
                border: `1px solid ${themeOrange}30`,
                mb: 2,
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <strong>Current Service:</strong>{" "}
                {get_user_job_by_id_data?.order?.service?.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Current Price:</strong> $
                {get_user_job_by_id_data?.order?.service?.price?.toLocaleString()}
              </Typography>
            </Box>

            <Typography variant="subtitle2" fontWeight="600">
              Select New Service
            </Typography>
            <CustomSelectBox
              options={serviceOptions}
              value={selectedService}
              onChange={setSelectedService}
              placeholder="Search and select a service..."
              isSearchable={true}
              isLoading={get_services_list_status === asyncStatus.LOADING}
            />

            {selectedService && (
              <Alert severity="info" sx={{ mt: 1 }}>
                <Typography variant="body2">
                  <strong>New Service:</strong> {selectedService.service?.name}
                </Typography>
                <Typography variant="body2">
                  <strong>New Price:</strong> ${selectedService.service?.price?.toLocaleString()}
                </Typography>
                {get_user_job_by_id_data?.order?.user?.type === "Member" && (
                  <Typography variant="body2">
                    <strong>Member Price:</strong> ${selectedService.service?.member_price?.toLocaleString()}
                  </Typography>
                )}
              </Alert>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={handleCloseServiceDialog}
            disabled={serviceLoading}
            sx={{ color: "gray" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleChangeService}
            disabled={serviceLoading || !selectedService}
            variant="contained"
            sx={{
              background: "linear-gradient(180deg, #F15A24 0%, #C53F10 100%)",
              "&:hover": {
                background: "linear-gradient(180deg, #E54920 0%, #B8390E 100%)",
              },
            }}
          >
            {serviceLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              "Change Service"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Materials Amount Dialog */}
      <Dialog
        open={materialsDialog}
        onClose={handleCloseMaterialsDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#1976d2",
            color: "white",
            fontWeight: "700",
          }}
        >
          Set Materials Amount
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Stack spacing={3} sx={{ pt: 1 }}>
            <Alert severity="info">
              Materials amount is exempt from the platform percentage fee. Use this for parts, supplies, or materials that the pro purchased for the job.
            </Alert>

            <TextField
              label="Materials Amount"
              type="number"
              value={materialsAmount}
              onChange={(e) => setMaterialsAmount(e.target.value)}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
              inputProps={{ min: 0, step: "0.01" }}
              placeholder="0.00"
            />

            {materialsError && (
              <Alert severity="error" sx={{ mt: 1 }}>
                {materialsError}
              </Alert>
            )}

            <Box
              sx={{
                backgroundColor: "#e3f2fd",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #90caf9",
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <strong>Order:</strong> {get_user_job_by_id_data?.order?.service?.name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Total Amount:</strong> ${get_user_job_by_id_data?.order?.total_amount
                  ? parseFloat(get_user_job_by_id_data.order.total_amount).toFixed(2)
                  : "0.00"}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Current Materials:</strong> ${get_user_job_by_id_data?.order?.materials_amount
                  ? parseFloat(get_user_job_by_id_data.order.materials_amount).toFixed(2)
                  : "0.00"}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={handleCloseMaterialsDialog}
            disabled={materialsLoading}
            sx={{ color: "gray" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleMaterialsSubmit}
            disabled={materialsLoading}
            variant="contained"
            sx={{
              background: "linear-gradient(180deg, #1976d2 0%, #1565c0 100%)",
              "&:hover": {
                background: "linear-gradient(180deg, #1565c0 0%, #0d47a1 100%)",
              },
            }}
          >
            {materialsLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              "Save Materials Amount"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Process Order Payment Dialog */}
      <Dialog
        open={processPaymentDialog}
        onClose={handleCloseProcessPayment}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: "#4CAF50",
            color: "white",
            fontWeight: "700",
          }}
        >
          Process Order Payment
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Stack spacing={3} sx={{ pt: 1 }}>
            {/* Order Summary */}
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                padding: "16px",
                borderRadius: "8px",
              }}
            >
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "700" }}>
                Order Summary
              </Typography>
              <Stack spacing={1}>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2">Order Total:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    ${parseFloat(get_user_job_by_id_data?.order?.total_amount || 0).toFixed(2)}
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2">Materials:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    ${parseFloat(get_user_job_by_id_data?.order?.materials_amount || 0).toFixed(2)}
                  </Typography>
                </Stack>
              </Stack>
            </Box>

            {/* Add Additional Items */}
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: "700" }}>
                Add Additional Items (Optional)
              </Typography>
              <Stack direction="row" spacing={1} sx={{ mb: 2 }}>
                <TextField
                  size="small"
                  placeholder="Item name"
                  value={newItemName}
                  onChange={(e) => setNewItemName(e.target.value)}
                  sx={{ flex: 2 }}
                />
                <TextField
                  size="small"
                  placeholder="Price"
                  type="number"
                  value={newItemPrice}
                  onChange={(e) => setNewItemPrice(e.target.value)}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                  sx={{ flex: 1 }}
                />
                <Button
                  variant="outlined"
                  onClick={handleAddItem}
                  sx={{ minWidth: "80px" }}
                >
                  Add
                </Button>
              </Stack>

              {/* Added Items List */}
              {additionalItems.length > 0 && (
                <Stack spacing={1}>
                  {additionalItems.map((item, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{
                        backgroundColor: "#e8f5e9",
                        padding: "8px 12px",
                        borderRadius: "4px",
                      }}
                    >
                      <Typography variant="body2">{item.name}</Typography>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="body2" fontWeight="600">
                          ${item.price.toFixed(2)}
                        </Typography>
                        <Button
                          size="small"
                          color="error"
                          onClick={() => handleRemoveItem(index)}
                          sx={{ minWidth: "auto", padding: "2px 8px" }}
                        >
                          Remove
                        </Button>
                      </Stack>
                    </Stack>
                  ))}
                </Stack>
              )}
            </Box>

            {/* Grand Total */}
            <Box
              sx={{
                backgroundColor: "#4CAF50",
                padding: "16px",
                borderRadius: "8px",
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" sx={{ color: "white", fontWeight: "700" }}>
                  Total to Charge:
                </Typography>
                <Typography variant="h5" sx={{ color: "white", fontWeight: "700" }}>
                  ${calculateProcessPaymentTotal().toFixed(2)}
                </Typography>
              </Stack>
              {additionalItems.length > 0 && (
                <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.8)" }}>
                  Includes {additionalItems.length} additional item(s): $
                  {additionalItems.reduce((sum, item) => sum + item.price, 0).toFixed(2)}
                </Typography>
              )}
            </Box>

            {/* Customer Info */}
            <Box
              sx={{
                backgroundColor: "#fff3e0",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ffe0b2",
              }}
            >
              <Typography variant="body2" color="textSecondary">
                <strong>Customer:</strong>{" "}
                {get_user_job_by_id_data?.order?.user?.first_name}{" "}
                {get_user_job_by_id_data?.order?.user?.last_name}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                <strong>Email:</strong> {get_user_job_by_id_data?.order?.user?.email}
              </Typography>
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button
            onClick={handleCloseProcessPayment}
            disabled={processPaymentLoading}
            sx={{ color: "gray" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleProcessPayment}
            disabled={processPaymentLoading}
            variant="contained"
            sx={{
              background: "linear-gradient(180deg, #4CAF50 0%, #388E3C 100%)",
              "&:hover": {
                background: "linear-gradient(180deg, #388E3C 0%, #2E7D32 100%)",
              },
            }}
          >
            {processPaymentLoading ? (
              <CircularProgress size={20} sx={{ color: "white" }} />
            ) : (
              `Charge $${calculateProcessPaymentTotal().toFixed(2)}`
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default OrderDetails;
